var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedNewProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8872 8.03245L13.9298 5.04297L4.18105 14.7917L3.18188 18.7907L7.18084 17.7904L16.8872 8.03245Z",
    stroke: "#007C92",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9297 5.04205L15.3952 3.57653C15.5124 3.45822 15.6519 3.36431 15.8056 3.30022C15.9593 3.23612 16.1242 3.20312 16.2907 3.20312C16.4572 3.20312 16.6221 3.23612 16.7758 3.30022C16.9295 3.36431 17.069 3.45822 17.1861 3.57653L19.2486 5.66424L16.8871 8.03382",
    stroke: "#007C92",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53174 14.4492L7.53153 17.449",
    stroke: "#007C92",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedNewProduct);
export default __webpack_public_path__ + "static/media/SelectedNewProduct.10fb3351a68b98e6b4c6fa6084c7d9b2.svg";
export { ForwardRef as ReactComponent };